import { Component, Input, ElementRef, ContentChildren, QueryList, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { ExpansionPanelHeaderComponent } from '../expansion-panel-header/expansion-panel-header.component';
import { BehaviorSubject } from 'rxjs';
@Component({
    selector: 'app-expansion-panel',
    templateUrl: './expansion-panel.component.html',
    styleUrls: ['./expansion-panel.component.scss'],
    standalone: false
})
export class ExpansionPanelComponent implements OnInit, AfterViewInit {

  @ViewChild('panel') panel: ElementRef;
  @ContentChildren(ExpansionPanelHeaderComponent) headerComponent: QueryList<ExpansionPanelHeaderComponent>;

  @Input() opened: boolean = false;
  @Input() open: BehaviorSubject<boolean>;
  @Input() close: BehaviorSubject<boolean>;

  ngOnInit(): void {
    this.open?.subscribe((value) => {
      if (value) {
        this.openPanel();
      }
    });

    this.close?.subscribe((value) => {
      if (value) {
        this.closePanel();
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.opened) {
      this.openPanel();
    }
  }

  openPanel(): void {
    this.headerComponent.first.openPanel(this.panel?.nativeElement);
  }

  closePanel(): void {
   this.headerComponent.first.closePanelOpened();
  }
}

